import $ from 'jquery';
import Swal from 'sweetalert2';

/**
 * Enhanced Native JS Server-Side table functionality.
 * Automatically handles AJAX requests, filtering, sorting, and pagination
 * with high-performance native fetch API, matching the Tiang table design.
 */
export function initServerTable() {
  $('.datatable[data-ajax-url]').each(function () {
    if (this.classList.contains('native-table-init')) return;
    this.classList.add('native-table-init');

    const table = this;
    const ajaxUrl = table.dataset.ajaxUrl;
    const card = table.closest('.card');
    if (!card) return;

    console.log('[NativeServerTable] Initializing native JS server table:', table.id);

    const tableBody =
      table.querySelector('tbody') ||
      (() => {
        const tbody = document.createElement('tbody');
        table.appendChild(tbody);
        return tbody;
      })();

    // 1. Locate or create card header controls
    let cardHeader = card.querySelector('.card-header');
    if (!cardHeader) {
      cardHeader = document.createElement('div');
      cardHeader.className = 'card-header bg-white border-bottom-0 pt-4 pb-0 px-4';
      card.insertBefore(cardHeader, card.firstChild);
    } else {
      // Remove title & icon as requested
      cardHeader.innerHTML = '';
    }
    cardHeader.classList.add('d-md-flex', 'align-items-center', 'justify-content-between');

    let lengthMenu =
      card.querySelector('.native-length-menu') || card.querySelector('#nativeLengthMenu');
    let searchInput =
      card.querySelector('.native-search-input') || card.querySelector('#nativeSearchInput');

    if (!lengthMenu || !searchInput) {
      const controlsContainer = document.createElement('div');
      controlsContainer.className =
        'd-flex flex-column flex-sm-row align-items-sm-center gap-3 ms-auto';
      controlsContainer.innerHTML = `
                <div class="d-flex align-items-center gap-2">
                    <span class="text-muted small fw-medium text-nowrap">Show:</span>
                    <select class="form-select form-select-sm rounded-pill px-3 shadow-none border-light-subtle native-length-menu" style="width: 80px;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50" selected>50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="position-relative" style="min-width: 260px;">
                    <span class="position-absolute top-50 start-0 translate-middle-y ps-3 text-muted">
                        <i class="bi bi-search"></i>
                    </span>
                    <input type="text" class="form-control form-control-sm rounded-pill ps-5 pe-3 shadow-none border-light-subtle native-search-input" placeholder="Cari...">
                </div>
            `;
      cardHeader.appendChild(controlsContainer);
      lengthMenu = controlsContainer.querySelector('.native-length-menu');
      searchInput = controlsContainer.querySelector('.native-search-input');
    }

    // 2. Locate or create footer controls
    let tableInfo =
      card.querySelector('.native-table-info') || card.querySelector('#nativeTableInfo');
    let paginationUl =
      card.querySelector('.native-pagination') || card.querySelector('#nativePagination');

    if (!tableInfo || !paginationUl) {
      let footer = card.querySelector('.native-footer-controls');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'row mt-4 align-items-center native-footer-controls';
        footer.innerHTML = `
                    <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
                        <span class="text-muted fw-medium small native-table-info"></span>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-center justify-content-md-end">
                        <nav aria-label="Page navigation">
                            <ul class="pagination pagination-sm mb-0 rounded-pill gap-1 native-pagination">
                            </ul>
                        </nav>
                    </div>
                `;
        const cardBody = card.querySelector('.card-body');
        if (cardBody) {
          cardBody.appendChild(footer);
        } else {
          card.appendChild(footer);
        }
      }
      tableInfo = footer.querySelector('.native-table-info');
      paginationUl = footer.querySelector('.native-pagination');
    }

    // 3. State variables
    let start = 0;
    let length = parseInt(lengthMenu ? lengthMenu.value : 50);
    let search = '';
    let orderColumn = null;
    let orderDir = 'asc';
    let drawCount = 0;
    let isFetching = false;

    // 4. Parse column configurations from headers
    const columns = [];
    const ths = table.querySelectorAll('thead th');
    ths.forEach((th, idx) => {
      const data = th.dataset.data || '';
      const noSort = th.classList.contains('no-sort');
      columns.push({
        data: data,
        name: data,
        orderable: !noSort,
        searchable: !noSort,
      });

      // Set up sorting behavior for sortable columns
      if (!noSort) {
        th.classList.add('sortable-header', 'cursor-pointer');
        th.style.userSelect = 'none';
        if (!th.querySelector('.sort-icon')) {
          const icon = document.createElement('i');
          icon.className = 'bi bi-arrow-down-up text-muted ms-1 small sort-icon';
          th.appendChild(icon);
        }

        th.addEventListener('click', function () {
          if (orderColumn === idx) {
            orderDir = orderDir === 'asc' ? 'desc' : 'asc';
          } else {
            orderColumn = idx;
            orderDir = 'asc';
          }

          ths.forEach((h, hidx) => {
            const icon = h.querySelector('.sort-icon');
            if (icon) {
              if (hidx === idx) {
                icon.className = `bi bi-arrow-${orderDir === 'asc' ? 'up' : 'down'} text-primary ms-1 small sort-icon`;
              } else {
                icon.className = 'bi bi-arrow-down-up text-muted ms-1 small sort-icon';
              }
            }
          });

          start = 0;
          fetchData();
        });
      }
    });

    // 5. AJAX Data Fetching
    async function fetchData() {
      if (isFetching) return;
      isFetching = true;

      const checkAll = card.querySelector('#check-all') || card.querySelector('#check-all-trash');
      if (checkAll) checkAll.checked = false;

      const bulkBar = document.getElementById('bulk-action-bar');
      if (bulkBar) {
        bulkBar.classList.add('d-none');
        bulkBar.classList.remove('d-flex');
      }

      tableBody.innerHTML = `
                <tr>
                    <td colspan="${ths.length}" class="text-center py-5">
                        <div class="spinner-border text-primary" role="status" style="width: 2rem; height: 2rem; border-width: 0.15em;"></div>
                        <div class="mt-2 text-muted small">Memuat data...</div>
                    </td>
                </tr>
            `;

      try {
        const params = new URLSearchParams();
        params.append('draw', ++drawCount);
        params.append('start', start);
        params.append('length', length);
        params.append('search[value]', search);

        columns.forEach((col, idx) => {
          params.append(`columns[${idx}][data]`, col.data);
          params.append(`columns[${idx}][name]`, col.name);
          params.append(`columns[${idx}][searchable]`, col.searchable ? 'true' : 'false');
          params.append(`columns[${idx}][orderable]`, col.orderable ? 'true' : 'false');
        });

        if (orderColumn !== null) {
          // Match sorting key back to database column using dataset.data if present
          const sortKey = columns[orderColumn].data || '';
          params.append('order[0][column]', orderColumn);
          params.append('order[0][dir]', orderDir);
        }

        // Append filter form parameters
        const filterForm = document.getElementById('filterForm');
        if (filterForm) {
          const formData = new FormData(filterForm);
          for (let [key, val] of formData.entries()) {
            if (val) {
              if (key.endsWith('[]')) {
                params.append(key.replace('[]', ''), val);
              } else {
                params.append(key, val);
              }
            }
          }
        }

        const separator = ajaxUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${ajaxUrl}${separator}${params.toString()}`, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            throw new Error('Unauthorized');
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (!result.data || result.data.length === 0) {
          tableBody.innerHTML = `
                        <tr>
                            <td colspan="${ths.length}" class="text-center py-5 text-muted">
                                <i class="bi bi-inbox fs-4 d-block mb-2"></i>
                                Tidak ada data tersedia
                            </td>
                        </tr>
                    `;
          renderPagination(result.recordsTotal || 0, 0);
          renderInfo(result.recordsTotal || 0, 0);
        } else {
          let html = '';
          result.data.forEach((row) => {
            html += '<tr>';
            ths.forEach((th) => {
              const dataKey = th.dataset.data;
              let val = '';
              if (dataKey) {
                val =
                  row[dataKey] !== undefined
                    ? row[dataKey]
                    : row[dataKey.toLowerCase()] !== undefined
                      ? row[dataKey.toLowerCase()]
                      : '';
              }
              const isCenter = th.classList.contains('text-center');
              const isRight = th.classList.contains('text-end');
              const alignClass = isCenter
                ? 'class="text-center"'
                : isRight
                  ? 'class="text-end"'
                  : '';
              html += `<td ${alignClass}>${val}</td>`;
            });
            html += '</tr>';
          });
          tableBody.innerHTML = html;

          renderPagination(result.recordsTotal || 0, result.recordsFiltered || 0);
          renderInfo(result.recordsTotal || 0, result.recordsFiltered || 0);
        }
      } catch (error) {
        console.error('[NativeServerTable] Fetch error:', error);
        if (error.message === 'Unauthorized') {
          Swal.fire({
            icon: 'warning',
            title: 'Sesi Berakhir',
            text: 'Silakan login kembali untuk melanjutkan.',
            confirmButtonText: 'Login',
          }).then(() => {
            window.location.reload();
          });
        } else {
          tableBody.innerHTML = `
                        <tr>
                            <td colspan="${ths.length}" class="text-center py-5 text-danger">
                                <i class="bi bi-exclamation-triangle fs-4 d-block mb-2"></i>
                                Gagal memuat data: ${error.message}
                            </td>
                        </tr>
                    `;
        }
      } finally {
        isFetching = false;
      }
    }

    function renderPagination(totalRecords, filteredRecords) {
      if (!paginationUl) return;
      paginationUl.innerHTML = '';

      const totalPages = Math.ceil(filteredRecords / length);
      console.log(
        '[NativeServerTable] rendering pagination. totalRecords:',
        totalRecords,
        'filteredRecords:',
        filteredRecords,
        'length:',
        length,
        'totalPages:',
        totalPages
      );
      if (isNaN(totalPages) || totalPages <= 0) return;

      const currentPage = Math.floor(start / length) + 1;
      const maxRange = 2;

      // Previous Button
      const prevLi = document.createElement('li');
      prevLi.className = `page-item ${currentPage === 1 ? 'disabled' : ''}`;
      prevLi.innerHTML = `<a class="page-link rounded-start-pill px-3 shadow-none" href="#" data-page="${currentPage - 1}">Sebelumnya</a>`;
      paginationUl.appendChild(prevLi);

      for (let i = 1; i <= totalPages; i++) {
        if (
          i === 1 ||
          i === totalPages ||
          (i >= currentPage - maxRange && i <= currentPage + maxRange)
        ) {
          const li = document.createElement('li');
          li.className = `page-item ${currentPage === i ? 'active' : ''}`;
          li.innerHTML = `<a class="page-link px-3 shadow-none" href="#" data-page="${i}">${i}</a>`;
          paginationUl.appendChild(li);
        } else if (i === currentPage - maxRange - 1 || i === currentPage + maxRange + 1) {
          const li = document.createElement('li');
          li.className = 'page-item disabled';
          li.innerHTML = '<span class="page-link px-2">...</span>';
          paginationUl.appendChild(li);
        }
      }

      // Next Button
      const nextLi = document.createElement('li');
      nextLi.className = `page-item ${currentPage === totalPages ? 'disabled' : ''}`;
      nextLi.innerHTML = `<a class="page-link rounded-end-pill px-3 shadow-none" href="#" data-page="${currentPage + 1}">Berikutnya</a>`;
      paginationUl.appendChild(nextLi);
    }

    function renderInfo(totalRecords, filteredRecords) {
      if (!tableInfo) return;

      if (filteredRecords === 0) {
        tableInfo.innerHTML = '<span class="text-muted">Menampilkan 0 data</span>';
        return;
      }

      const startNum = start + 1;
      const endNum = Math.min(start + length, filteredRecords);

      let infoText = `Menampilkan <b class="text-dark">${startNum}-${endNum}</b> dari <b class="text-dark">${filteredRecords}</b>`;
      if (filteredRecords < totalRecords) {
        infoText += ` (disaring dari <b class="text-dark">${totalRecords}</b> data)`;
      }
      tableInfo.innerHTML = infoText;
    }

    // Debounce helper
    let debounceTimeout;
    function debounce(func, delay = 300) {
      return function (...args) {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => func.apply(this, args), delay);
      };
    }

    // Event Listeners
    if (lengthMenu) {
      lengthMenu.addEventListener('change', function () {
        length = parseInt(this.value);
        start = 0;
        fetchData();
      });
    }

    if (searchInput) {
      searchInput.addEventListener(
        'input',
        debounce(function () {
          search = this.value.trim();
          start = 0;
          fetchData();
        }, 300)
      );
    }

    if (paginationUl) {
      paginationUl.addEventListener('click', function (e) {
        e.preventDefault();
        const link = e.target.closest('a');
        if (
          !link ||
          link.parentNode.classList.contains('disabled') ||
          link.parentNode.classList.contains('active')
        ) {
          return;
        }
        const targetPage = parseInt(link.dataset.page);
        start = (targetPage - 1) * length;
        fetchData();
        table.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    const filterForm = document.getElementById('filterForm');
    if (filterForm) {
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        start = 0;
        fetchData();
      });
    }

    $(document).on('crud-success', function () {
      fetchData();
    });

    // Trigger initial fetch
    fetchData();
  });
}
